var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginatedToggleButton',{attrs:{"label":"Microsites","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"override-headers":_vm.overrideHeaders,"tabs-list":_vm.tabsList,"visible-pages-numbers":5,"is-has-tabs":"","is-show-total-label":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }